import {
  getCompDirectEnergyDropdown,
  getCompIndirectEmitDropdown,
  getCompIndirectEnergyDropdown,
  getCompIntermediateEnergyDropdown,
  getCompUseGwpDropdown,
  getCurrencyDropdown,
  getProdComponentDropdown,
  getProdManufacturingMaterialDropdown,
  getProdManufacturingProcessDropdown,
  getProdManufacturingWaterDropdown,
  getProdProductionMachineVehicleDropdown,
  getProdSurplusResourcesDropdown,
  getProductDirectEmission41_1cDropdown,
  getProductDisposalMethodMaintenance41_2bDropdown,
  getProductEnergyInputMaintenance41_2aDropdown,
  getProductFlow41_6Dropdown,
  getProductFlow42_1MaterialEnergyDropdown,
  getProductFlow43_1MeansOfTransportationDropdown,
  getProductFlow43_1PackagingPerFUDropdown,
  getProductFlow43_4DisposalMethodDropdown,
  getProductFlow44_1NextWasteDropdown,
  getProductFlow44_1ProcessedDropdown,
  getProductFlow45_1DisposedDropdown,
  getProductFlow45_2MaterialDropdown,
  getProductFlow46MaterialDropdown,
  getProductFlow46NamePartInFUDropdown,
  getProductInstallationDisposal37_2Dropdown,
  getProductInstallationMaterial37_1Dropdown,
  getProductInstallationMaterialLost37_4Dropdown,
  getProductLossesA2MaterialDropdown,
  getProductLossesMaterialDropdown,
  getProductManufacturingProcess33_1Dropdown,
  getProductMaterialLost35Dropdown,
  getProductMaterialUsage34_1aDropdown,
  getProductPackagingUsage34_1bDropdown,
  getProductProductionMachinesEnergy34_2aDropdown,
  getProductProductionVehiclesEnergy34_2bDropdown,
  getProductSpecificPackagingMaterialDropdown,
  getProductSurplusResourcesDisposal34_3Dropdown,
  getProductSurplusTransportA2DisposalMethodDropdown,
  getProductSurplusTransportCountryDropdown,
  getProductSurplusTransportDisposalMethodDropdown,
  getProductTransportationMeans36Dropdown,
  getProductTransportationMeans38Dropdown,
  getProductTransportCountryDropdown,
  getProductTransportMeansDropdown,
  getProductWaterConsumptionMaintenance41_2aDropdown,
  getProductWaterType34_1cDropdown,
  getProductWaterTypeDropdown,
  getTransportCountryData,
  getTransportDeliveriesData,
  getTransportPackagingFrom34_1bDropdown,
  getTransportPackagingFromA1Dropdown,
  getTransportPackagingMaterialDropdown,
} from "../../../apis/Dropdown";

const noop = () => {};

/**
 * Fire LCA dropdown GETs in parallel so option lists are warm before tables mount.
 * Each getter writes through to the shared lcaDropdownCache when responses arrive.
 */
export function prefetchLCADropdowns(productId) {
  if (!productId) return;

  const pid = productId;

  getTransportDeliveriesData({ setDropdownData: noop });
  getTransportCountryData({ setDropdownData: noop });

  getCompDirectEnergyDropdown({ setDropdown: noop });
  getCompUseGwpDropdown({ setDropdown: noop });
  getCompIndirectEmitDropdown({ setDropdown: noop });
  getCompIndirectEnergyDropdown({ setDropdown: noop });
  getCompIntermediateEnergyDropdown({ setDropdown: noop });

  getProdComponentDropdown({ setDropdown: noop });
  getProductSpecificPackagingMaterialDropdown({ setDropdown: noop });
  getTransportPackagingMaterialDropdown({ flow: "31.2a", setDropdown: noop });
  getTransportPackagingMaterialDropdown({ flow: "31.2b", setDropdown: noop });
  getProductWaterTypeDropdown({ setDropdown: noop });
  getProductSurplusTransportDisposalMethodDropdown({ setDropdown: noop });
  getProductSurplusTransportCountryDropdown({ setDropdown: noop });
  getProductLossesMaterialDropdown({ setDropdown: noop });
  getProductTransportMeansDropdown({ setDropdown: noop });
  getProductTransportCountryDropdown({ setDropdown: noop });

  getTransportPackagingFromA1Dropdown({ productId: pid, setDropdown: noop });

  getProductManufacturingProcess33_1Dropdown({ setDropdown: noop });
  getCurrencyDropdown({ setDropdown: noop });
  getProductSurplusTransportA2DisposalMethodDropdown({ setDropdown: noop });
  getProductLossesA2MaterialDropdown({ setDropdown: noop });

  getProdManufacturingProcessDropdown({ setDropdown: noop });
  getProdManufacturingMaterialDropdown({ setDropdown: noop });
  getProdManufacturingWaterDropdown({ setDropdown: noop });
  getProdProductionMachineVehicleDropdown({ setDropdown: noop });
  getProdSurplusResourcesDropdown({ setDropdown: noop });

  getProductMaterialUsage34_1aDropdown({ setDropdown: noop });
  getProductPackagingUsage34_1bDropdown({ setDropdown: noop });
  getProductWaterType34_1cDropdown({ setDropdown: noop });
  getProductProductionMachinesEnergy34_2aDropdown({ setDropdown: noop });
  getProductProductionVehiclesEnergy34_2bDropdown({ setDropdown: noop });
  getProductSurplusResourcesDisposal34_3Dropdown({ setDropdown: noop });
  getProductMaterialLost35Dropdown({ setDropdown: noop });
  getProductTransportationMeans36Dropdown({ setDropdown: noop });
  getTransportPackagingFrom34_1bDropdown({ productId: pid, setDropdown: noop });
  getProductTransportationMeans38Dropdown({ setDropdown: noop });

  getProductInstallationMaterial37_1Dropdown({ setDropdown: noop });
  getProductInstallationDisposal37_2Dropdown({ setDropdown: noop });
  getProductInstallationMaterialLost37_4Dropdown({ setDropdown: noop });

  getProductDirectEmission41_1cDropdown({ setDropdown: noop });
  getProductEnergyInputMaintenance41_2aDropdown({ setDropdown: noop });
  getProductWaterConsumptionMaintenance41_2aDropdown({ setDropdown: noop });
  getProductDisposalMethodMaintenance41_2bDropdown({ setDropdown: noop });
  getProductFlow41_6Dropdown({ setDropdown: noop });

  getProductFlow43_1MeansOfTransportationDropdown({ setDropdown: noop });
  getProductFlow43_1PackagingPerFUDropdown({ setDropdown: noop });
  getProductFlow43_4DisposalMethodDropdown({ setDropdown: noop });

  getProductFlow44_1ProcessedDropdown({ setDropdown: noop });
  getProductFlow44_1NextWasteDropdown({ setDropdown: noop });

  getProductFlow45_1DisposedDropdown({ setDropdown: noop });
  getProductFlow45_2MaterialDropdown({ setDropdown: noop });

  getProductFlow46MaterialDropdown({ setDropdown: noop });
  getProductFlow46NamePartInFUDropdown({ productId: pid, setDropdown: noop });

  getProductFlow42_1MaterialEnergyDropdown({ setDropdown: noop });
}
